import React from 'react';
import moment from 'moment';

import Tags from '../../components/Tags';
import { Link } from '../../components';
import {
  CardContainer,
  Image,
  ChallengeInfo,
  ChallengeName,
  ChallengeInfoHeader,
  ChallengeDetails,
  DetailsLabel,
} from './styles';

export default function ChallengeCard({ name, image, isTournament, createdAt, editedAt, link }) {
  const getEditedAtTime = () => {
    let time = editedAt ? editedAt : createdAt;
    let ago;
    let date = moment(time)._d;
    if (!time) {
      ago = '-';
    } else {
      ago = moment(date).fromNow();
    }
    return ago;
  };

  return (
    <CardContainer>
      <Link to={link}>
        <Image image={image} />
        <ChallengeInfo>
          <ChallengeInfoHeader>
            <ChallengeName>{name}</ChallengeName>
          </ChallengeInfoHeader>
          <ChallengeDetails>
            <DetailsLabel>Created At:&nbsp;</DetailsLabel>
            {moment(createdAt).format('ll')}
          </ChallengeDetails>
          <ChallengeDetails>
            <DetailsLabel>Edited At:&nbsp;</DetailsLabel>
            {getEditedAtTime()}
          </ChallengeDetails>
          <Tags tags={[isTournament ? 'Tournament' : 'Challenge']} />
        </ChallengeInfo>
      </Link>
    </CardContainer>
  );
}
